"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Title_1 = __importDefault(require("../Title"));
var Loader_1 = __importDefault(require("../Loader"));
var CarsFilters = function (_a) {
    var onFiltersReset = _a.onFiltersReset, onClickShow = _a.onClickShow, show = _a.show, title = _a.title, isLoading = _a.isLoading, children = _a.children;
    var _b = react_1.useState(true), toggle = _b[0], setToggle = _b[1];
    var change = react_1.useMemo(function () { return onClickShow !== null && onClickShow !== void 0 ? onClickShow : setToggle; }, [onClickShow]);
    var isShow = react_1.useMemo(function () { return show !== null && show !== void 0 ? show : toggle; }, [show, toggle]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "aui-FiltersWrap-head", id: "aui-filters" },
            react_1.default.createElement("div", { className: "container" },
                react_1.default.createElement(Title_1.default, { level: "h1" }, title),
                react_1.default.createElement("button", { type: "button", className: classnames_1.default('aui-FiltersWrap-toggle', {
                        'aui-FiltersWrap-toggle_open': isShow,
                    }), onClick: function () { return change(!isShow); }, "data-testid": "toggleButton" },
                    react_1.default.createElement("span", null, "\u0440\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C"),
                    react_1.default.createElement("span", null, "\u0441\u0432\u0435\u0440\u043D\u0443\u0442\u044C"),
                    "\u00A0\u0444\u0438\u043B\u044C\u0442\u0440"))),
        react_1.default.createElement("div", { className: classnames_1.default('aui-FiltersWrap-body', {
                'aui-FiltersWrap-body_open': isShow,
            }) },
            react_1.default.createElement("div", { className: "container" },
                react_1.default.createElement("div", { className: "aui-FiltersWrap-tools" },
                    react_1.default.createElement("div", { className: "aui-FiltersWrap-title" },
                        "\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u043F\u043E\u0438\u0441\u043A\u0430 ",
                        isLoading && react_1.default.createElement(Loader_1.default, { size: 2 })),
                    react_1.default.createElement("button", { className: "aui-FiltersWrap-close", type: "button", onClick: onFiltersReset }, "\u0441\u0431\u0440\u043E\u0441\u0438\u0442\u044C")),
                children))));
};
exports.default = CarsFilters;
